var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "ex-widget" }, on: { enter: _vm.enter } },
    [
      _vm.show && _vm.modal
        ? _c("ex-mask", { staticClass: "transparent" }, [
            _c("div", {
              staticClass: "toast",
              domProps: { innerHTML: _vm._s(_vm.fragment()) }
            })
          ])
        : _vm.show && !_vm.modal
          ? _c("div", {
              staticClass: "toast",
              domProps: { innerHTML: _vm._s(_vm.fragment()) }
            })
          : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }